import { h } from 'preact';
import { ErrorLayout } from 'features/verify/ui/error-layout';
import { useLocalization } from 'model/localization.model';

export const CameraError = () => {
	const t = useLocalization();

	return (
		<ErrorLayout
			title={t('camera.err.title')}
			description={
				<span
					dangerouslySetInnerHTML={{
						__html: t('camera.err.subtitle', {
							'camera.err.subtitle.sub': `<a target="_blank" href="${t('camera.err.subtitle.url')}">${t('camera.err.subtitle.sub')}</a>`,
						}),
					}}
				/>
			}
		/>
	);
};
